import { render, staticRenderFns } from "./ArchivedLists.vue?vue&type=template&id=2c3a2e64&"
import script from "./ArchivedLists.vue?vue&type=script&lang=js&"
export * from "./ArchivedLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports